import { useState } from 'react'
import { sampleTranscript, derivedTasks } from './fixtures'

const PRIORITY_LABEL = { high: 'High', medium: 'Medium', low: 'Low' } as const

/**
 * Reduced-motion users get the idea rather than an empty frame: the same
 * before and after, switched by hand.
 */
export default function StaticFallback() {
  const [view, setView] = useState<'before' | 'after'>('before')

  return (
    <div>
      <div
        role="group"
        aria-label="Toggle transcript view"
        className="mb-6 inline-flex rounded-lg border border-white/[0.08] bg-surface-raised p-1"
      >
        {(['before', 'after'] as const).map((option) => (
          <button
            key={option}
            type="button"
            onClick={() => setView(option)}
            aria-pressed={view === option}
            className={`min-w-[4.5rem] rounded-md px-3 py-1.5 text-caption font-medium capitalize transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 ${
              view === option
                ? 'bg-primary-500 text-white'
                : 'text-white/50 hover:text-white'
            }`}
          >
            {option}
          </button>
        ))}
      </div>

      {view === 'before' ? (
        <div className="space-y-3 rounded-xl border border-white/[0.08] bg-surface-overlay p-6">
          {sampleTranscript.map((line) => (
            <p
              key={line.id}
              className={line.isAction ? 'text-body text-white' : 'text-body text-white/55'}
            >
              {line.text}
            </p>
          ))}
        </div>
      ) : (
        <div className="rounded-xl bg-surface-inset p-4 ring-1 ring-white/[0.06]">
          <p className="mb-3 text-caption font-semibold uppercase tracking-wide text-white/40">
            To Do
          </p>
          <div className="space-y-2">
            {derivedTasks.map((task) => (
              <div
                key={task.id}
                className="rounded-lg border border-white/[0.08] bg-surface-overlay p-3 shadow-sm"
              >
                <p className="text-body font-medium text-white">{task.title}</p>
                <div className="mt-3 flex flex-wrap items-center gap-2">
                  <span className="rounded px-1.5 py-0.5 text-caption font-medium bg-white/[0.06] text-white/70">
                    {PRIORITY_LABEL[task.priority]}
                  </span>
                  <span className="text-caption text-white/55">{task.assignee}</span>
                  <span className="text-caption text-white/25">·</span>
                  <span className="text-caption text-white/55">{task.due}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
